<div class="appFormContainer">
  <app-dynamic-form [fields]="fields"></app-dynamic-form>
</div>
